import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  Tabs,
  Nav,
  Tab,
  Table,
  Modal,
  Image,
  Container,
} from "react-bootstrap";
import ModalImage from "react-modal-image";
import "../../Common/Common.css";
import { appConfig } from "../../../config";
var dateFormat = require("dateformat");

class PatientsOrderView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const data =
      this.props.PatientsOrdersDtls && this.props.PatientsOrdersDtls.item
        ? this.props.PatientsOrdersDtls.item
        : null;
    const reorderduration =
      data !== null && data.prcpId && data.prcpId.reOdrDueDte;
    const createdAt =
      data !== null && data.createdAt ? new Date(data.createdAt) : null;
    const hasValidCreatedAt =
      createdAt instanceof Date && !Number.isNaN(createdAt.getTime());
    const hasValidReorderDuration =
      reorderduration !== undefined &&
      reorderduration !== null &&
      reorderduration !== "" &&
      !Number.isNaN(Number(reorderduration));
    const reorderDate =
      hasValidCreatedAt && hasValidReorderDuration
        ? new Date(
            createdAt.getFullYear(),
            createdAt.getMonth(),
            createdAt.getDate() + Number(reorderduration)
          )
        : null;

    //Destructuring
    const { show, close } = this.props;

    return (
      <div>
        <div>
          <Modal
            show={show}
            onHide={close}
            animation={false}
            className="chemistmodeldiv"
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Patient Order Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <Row>
                <Col xs={12} sm={12} md={8} lg={8}>
                  <h6 style={{ lineHeight: 1.5 }}>
                    Order ID :{" "}
                    <span className="cmn_Cap">
                      {data !== null && data.orderNo ? data.orderNo : null}
                    </span>
                    <br />
                    Order Type :{" "}
                    <span className="cmn_Cap">
                      {data !== null && data.orderTrk ? data.orderTrk : null}{" "}
                      Order
                    </span>
                  </h6>
                </Col>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <h6 style={{ lineHeight: 1.5 }}>
                    Order Status :{" "}
                    <span className="cmn_Cap">
                      {data !== null && data.status ? data.status : null}
                    </span>
                    <br />
                    Order Date :{" "}
                    <span className="cmn_Cap">
                      {data !== null &&
                        data.createdAt !== null &&
                        dateFormat(data.createdAt, "dd-mmm-yyyy")}
                    </span>
                  </h6>
                </Col>
              </Row>
              <hr />

              <Row>
                <Col xs={12} sm={12} md={4} lg={4}>
                  <div>
                    <p className="boldClass">Order From:</p>
                    <p>
                      <span className="cmn_Cap"> Name : </span>{" "}
                      {data !== null && data.orderFrom
                        ? data.orderFrom.fullName
                        : "---"}
                      <br />
                      <span className="cmn_Cap"> Mobile : </span>{" "}
                      {data !== null &&
                      data.orderFrom !== null &&
                      data.orderFrom
                        ? data.orderFrom.mobileNo
                        : "---"}
                      <br />
                      <span className="cmn_Cap"> Email : </span>{" "}
                      {data !== null &&
                      data.patientDtls &&
                      data.patientDtls.email
                        ? data.patientDtls.email
                        : "---"}
                      <br />
                      <span className="cmn_Cap"> City : </span>{" "}
                      {data !== null &&
                      data.patientDtls &&
                      data.patientDtls.city
                        ? data.patientDtls.city
                        : "---"}
                      <br />
                      <span className="cmn_Cap"> Address : </span>{" "}
                      {data !== null && data.addr},{" "}
                      {data !== null && data.pincode}
                    </p>
                  </div>
                </Col>

                <Col xs={12} sm={12} md={4} lg={4} />

                <Col xs={12} sm={12} md={4} lg={4}>
                  <div>
                    <p className="boldClass">Order To:</p>

                    <p>
                      <span className="cmn_Cap"> Name : </span>{" "}
                      {data !== null && data.orderTo
                        ? data.orderTo.fullName
                        : "---"}
                      <br />
                      <span className="cmn_Cap"> Org Name : </span>{" "}
                      {data !== null && data.orderToName
                        ? data.orderToName
                        : "---"}
                      <br />
                      <span className="cmn_Cap"> Mobile : </span>{" "}
                      {data !== null && data.orderTo !== null && data.orderTo
                        ? data.orderTo.mobileNo
                        : "---"}
                      <br />
                      <span className="cmn_Cap"> City : </span>{" "}
                      {data !== null && data.city ? data.city : "---"}
                    </p>
                  </div>
                </Col>
              </Row>
              <hr />

              <Table responsive bordered className="cmnMainTable">
                <thead>
                  <tr>
                    <th>Patient Name </th>
                    <th>Doctor Name </th>
                    <th>Remarks</th>
                    <th>Prescription Image </th>
                    <th>Prescription Date </th>
                    <th>Re-Order Date </th>
                    {/* <th>Created Date & Time </th> */}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {data !== null && data.prcpId && data.prcpId.patientName}
                    </td>
                    <td className="cmn_Cap">
                      {data !== null && data.prcpId && data.prcpId.doctorName}
                    </td>
                    <td>
                      {" "}
                      {data !== null &&
                      data.prcpId &&
                      data.prcpId.prscrptnTag ? (
                        data.prcpId.prscrptnTag
                      ) : (
                        <span style={{ fontStyle: "italic" }}>
                          -No notes provided -
                        </span>
                      )}
                    </td>

                    <td className="centerAlign">
                      {data && data.prcpId && data.prcpId.prcptImg ? (
                        <ModalImage
                          small={
                            data &&
                            data.prcpId &&
                            data.prcpId.prcptImg &&
                            appConfig.ip +
                              `/attachments/preview/${encodeURIComponent(
                                data.prcpId.prcptImg
                              )}`
                          }
                          large={
                            data &&
                            data.prcpId &&
                            data.prcpId.prcptImg &&
                            appConfig.ip +
                              `/attachments/preview/${encodeURIComponent(
                                data.prcpId.prcptImg
                              )}`
                          }
                          hideDownload={true}
                          hideZoom={true}
                          className="imageModalClass"
                        />
                      ) : (
                        "Preview not available"
                      )}
                    </td>
                    <td>
                      {data !== null &&
                        data.prcpId &&
                        data.prcpId.prscrptnDate !== null &&
                        data.prcpId.prscrptnDate !== undefined &&
                        dateFormat(data.prcpId.prscrptnDate, "mediumDate")}
                    </td>
                    <td className="cmn_Cap">
                      {data !== null && data.prcpId && data.prcpId.oneTime
                        ? "NA"
                        : reorderDate
                        ? dateFormat(reorderDate, "mediumDate")
                        : "NA"}
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }} />
          </Modal>
        </div>
      </div>
    );
  }
}

export default PatientsOrderView;
